import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMG } from "@/lib/content";
import { Eyebrow, Reveal } from "./Reveal";

const STATS = [
  ["10+", "Years of experience"],
  ["4", "Premium stone types"],
  ["5–10", "Business-day typical install"],
  ["A+", "BBB accredited rating"],
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section id="about" ref={ref} data-testid="about-section" className="relative bg-[#F5F0E6] py-24 text-[#0B0F17] lg:py-36">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:items-center">
        <Reveal className="relative lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden" style={{ clipPath: "polygon(0 0, 100% 0, 100% 88%, 82% 100%, 0 100%)" }}>
            <motion.img style={{ y, scale: 1.18 }} src={IMG.fireplace} alt="Black stone fireplace surround fabricated by KS Granite House" loading="lazy" className="h-full w-full object-cover" />
          </div>
          <img src={IMG.mark} alt="" aria-hidden="true" className="absolute -bottom-8 -right-4 h-28 w-28 rounded-full border-4 border-[#F5F0E6] bg-[#0F1622] object-contain p-2 sm:h-36 sm:w-36" />
        </Reveal>
        <div className="lg:col-span-7 lg:pl-10">
          <Reveal><Eyebrow light>About KS Granite House</Eyebrow></Reveal>
          <Reveal delay={0.1}><h2 className="mt-5 font-display text-4xl leading-[1.05] sm:text-5xl lg:text-6xl">Natural beauty. Expertly crafted. <span className="italic text-[#8a6d2f]">Built to last.</span></h2></Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-2xl text-[#3E434C]">
              KS Granite House is a Kansas City countertop fabricator turning granite, quartz, marble and quartzite into surfaces made just for you. Whether you are planning a sleek kitchen upgrade or a luxurious bathroom remodel, our selection and flexible pricing options mean there is something for every taste and budget.
            </p>
            <p className="mt-4 max-w-2xl text-[#3E434C]">
              With 10+ years of experience, laser templating and fabrication in our own shop, we control quality from the first measurement to the final polish, serving homeowners and the trade across Kansas and Missouri.
            </p>
          </Reveal>
          <dl className="mt-12 grid grid-cols-2 gap-px bg-[#0B0F17]/10 sm:grid-cols-4">
            {STATS.map(([k, v], i) => (
              <Reveal key={v} delay={0.1 * i} className="bg-[#F5F0E6] p-5">
                <dt className="font-display text-5xl leading-none">{k}</dt>
                <dd className="mt-2 text-xs uppercase tracking-[0.14em] text-[#4B5059]">{v}</dd>
              </Reveal>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};
